import React, {useEffect, useState} from 'react'
import ReactFAQGroup from "./ReactFAQGroup"
import Select from 'react-select'
import ReactFAQItem from "./ReactFAQItem"

const ReactFAQ = ({faqData, moduleIdx}) => {
	const data = faqData,
		moduleId = data.id,
		//groupedItems = groupByKey(data.items, 'category'),
		filterSetup = data.filterSetup,
		labels = data.labels;

    const [searchString, setSearchString] = useState('')
	const [searchKeywords, setSearchKeywords] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
	const [filteredItems, setFilteredItems] = useState(searchString !== '' || selectedOption ? data.items.filter((item) => filterItems(item)) : data.items);

    function filterItems(item) {
		let itemIsMatch = false;

		//if item matches selected category
		if(selectedOption ? item.category === selectedOption.value : true) {
			for (let i = 0; i < searchKeywords.length; i++) {
				//check if one of keywords matches topic or content
				const keywordMatchesItem = item.topic.toLowerCase().includes(searchKeywords[i]) || (item.answerHtml && item.answerHtml.toLowerCase().includes(searchKeywords[i]))

				itemIsMatch = keywordMatchesItem;
				// one match is enough
				if(keywordMatchesItem) break;
			}
		}

		//check if searchString has synonyms
        return itemIsMatch
    }

    function groupByKey(xs, key) {
        return xs.reduce(function(rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x)
            return rv
        }, {})
    }


    function renderHits() {
        return (
            <p className="m-react-faq__hits" aria-live={"polite"}><b>{filteredItems.length}</b> {labels.hits}</p>
        )
    }


    function renderGroups() {
        // categories keep the order of the backend data (filterSetup.select.options);
        // Object.entries would reorder the numeric category keys ascending
        const orderMap = filterSetup.select.options.reduce((acc, option, index) => {
            acc[option.value.toString()] = index
            return acc
        }, {})
		const groupedItems= groupByKey(filteredItems, 'category');
		let sortedEntries = Object.entries(groupedItems);
		if(selectedOption) {
			sortedEntries = sortedEntries.filter((item) => item[0].toString() === selectedOption.value.toString());
		}
		else {
			sortedEntries = sortedEntries.sort(([a], [b]) => {
				return orderMap[a.toString()] - orderMap[b.toString()]
			})
		}

        return sortedEntries.map(([key, categoryItems], i) => {
            const categoryHeadline = filterSetup.select.options.find((item) => item.value.toString() === key.toString()).label

            const sortedCategoryItems = sortItemsByTitleAndPriority(categoryItems);

            return <ReactFAQGroup key={i} searchKeywords={searchKeywords} headline={categoryHeadline} headlineLevel={parseInt(data.headlineLevel) + 1} items={sortedCategoryItems} moduleId={moduleId} index={i} labels={labels}/>
        })
    }

	function sortItemsByTitleAndPriority(items) {

		//sort alphabetically
		const sortedFilteredItems = items.slice().sort((itemA, itemB) => {
			return itemA.topic.toLowerCase().localeCompare(itemB.topic.toLowerCase())
		})

		//sort by priority

		return sortedFilteredItems.slice().sort((itemA, itemB) => {
			let higherPrio = 0;

			// smaller numbers are more important than bigger numbers
			if(itemA.prio > 0 && itemB.prio > 0 && itemA.prio < itemB.prio) higherPrio=-1;
			// 0 is less important than any other number
			if(itemA.prio > 0 && itemB.prio === 0) higherPrio=-1;
			if(itemA.prio === 0 && itemB.prio > 0) higherPrio=1;
			return higherPrio
		});
	}

    function renderNoResults() {
        return (
            <p className="m-react-faq__no-results">{labels.noResults}</p>
        )
    }

    function renderContent() {
		if(filteredItems.length > 0) return renderGroups()
		else return renderNoResults()
    }

    function handleFilterChange(e) {
        setSearchString(e.target.value.toLowerCase())
    }

	useEffect(() => {
		let synonyms = (faqData.synonyms && faqData.synonyms[searchString]) ? [searchString, ...faqData.synonyms[searchString]] : [searchString];

		setSearchKeywords(synonyms);

	}, [searchString]);

	useEffect(() => {
		setFilteredItems(searchKeywords.length > 0 || selectedOption ? data.items.filter((item) => filterItems(item)) : data.items)
	}, [searchKeywords, selectedOption]);

    return (
        <>
            <div className="m-react-faq__filter">
				<div className="m-react-faq__filter-item ">
					<div className={"input-label-wrapper input-textfield"}>
						<input name={"search-input-" + moduleIdx} type="search" aria-label={filterSetup.textInput.label} placeholder={filterSetup.textInput.placeholder}
							   onChange={handleFilterChange}/>
					</div>
				</div>
				<div className="m-react-faq__filter-item">
					<div className="select-wrapper">
						<Select
							className = "select"
							classNamePrefix = "select"
							defaultValue={selectedOption}
							isClearable={true}
							isSearchable = {true}
							onChange={setSelectedOption}
							options={filterSetup.select.options}
							placeholder={filterSetup.select.placeholder}
							aria-label={filterSetup.select.label}
						/>
					</div>
                </div>
            </div>
			{data.labels.info && (
				<div className={"m-react-faq__info"}>
					<div className={"m-react-faq__info-icon"} aria-hidden={true}></div>
					<p>{data.labels.info}</p>
				</div>
			)}
            <div className="m-react-faq__meta">
                {renderHits()}
            </div>
            <div className="m-react-faq__content">
                {renderContent()}
            </div>
        </>
    )
}

export default ReactFAQ
